export default __webpack_public_path__ + "static/media/Engage_App_Icon.74a13aa6.svg";